<div class="view">
  <div class="head"></div>
  <div class="body">
    <div [style.margin]="'0px 0px -6.5px 0px'">
      <img
        src="https://wikipapa.org/images/banner-inicio.jpg"
        style="object-fit: contain; background-size: cover"
        width="100%"
      />
    </div>

    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around center"
      [style.padding]="'0 15vw'"
    >
      <div
        fxFlex="60%"
        fxFlex.sm="60%"
        fxFlex.xs="100%"
        [style.padding]="'0em 2em'"
      >
        <p class="p1">
          <span class="b1">Nuestro objetivo</span> es contribuir a la
          conservación in-situ de la diversidad de variedades endémicas de papas
          nativas de los Andes a través del monitoreo en tiempo real a través de
          una colaboración de ciencia ciudadana
        </p>
      </div>
      <div
        fxFlex="40%"
        fxFlex.sm="40%"
        fxFlex.xs="100%"
        [style.margin]="'0px 0px -6.5px 0px'"
      >
        <img
          src="https://wikipapa.org/images/papas-juntas.png"
          style="object-fit: contain; background-size: cover"
          width="100%"
        />
      </div>
    </div>

    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around center"
      [style.padding]="'0% 15%'"
    >
      <div
        fxFlex="33.3"
        fxFlex.sm="100"
        fxFlex.xs="100"
        [style.padding]="'0em 2em'"
      >
        <div
          [style.background]="'url(https://wikipapa.org/images/trio1.jpg)'"
          [style.background-size]="'contain'"
          [style.background-repeat]="'no-repeat'"
          [style.background-position]="'center'"
          [style.background-color]="'#fff'"
          [style.height]="'20em'"
        ></div>
      </div>
      <div
        fxFlex="33.3"
        fxFlex.sm="100"
        fxFlex.xs="100"
        [style.padding]="'0em 2em'"
      >
        <div
          [style.background]="'url(https://wikipapa.org/images/trio2.jpg)'"
          [style.background-size]="'contain'"
          [style.background-repeat]="'no-repeat'"
          [style.background-position]="'center'"
          [style.background-color]="'#fff'"
          [style.height]="'20em'"
        ></div>
      </div>
      <div
        fxFlex="33.3"
        fxFlex.sm="100"
        fxFlex.xs="100"
        [style.padding]="'0em 2em'"
      >
        <div
          [style.background]="'url(https://wikipapa.org/images/trio3.jpg)'"
          [style.background-size]="'contain'"
          [style.background-repeat]="'no-repeat'"
          [style.background-position]="'center'"
          [style.background-color]="'#fff'"
          [style.height]="'20em'"
        ></div>
      </div>
    </div>

    <div [style.padding]="'0% 15%'">
      <div fxLayout="row wrap" class="frame-diversity">
        <div
          fxFlex="100"
          fxFlex.sm="100"
          fxFlex.xs="100"
          [style.padding]="'1em 2em'"
        >
          <span [style.font-size]="'2.3em'"
            >La diversidad de papas nativas</span
          >
        </div>

        <div
          fxFlex="50"
          fxFlex.sm="100"
          fxFlex.xs="100"
          [style.padding]="'1.5em 2em'"
        >
          <span [style.font-size]="'1.6em'">
            Es conservada por un sistema de agricultura familiar en los Andes de
            Perú y Bolivia. Cada integrante de la familia cumple un papel
            especifico en las diversas labores que demanda el cultivo de la papa
            y los
          </span>
        </div>

        <div fxFlex="50" [style.padding]="'1.5em 2em'">
          <span [style.font-size]="'1.6em'">
            cultivares generalmente, son mezclas de varios genotipos con
            caracteristicas propias y relacionadas con los usos y costumbres de
            los agricultores que las emplean en sus fincas.
          </span>
        </div>
      </div>
    </div>

    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around center"
      [style.background-color]="'#FFFFDC'"
      [style.padding]="'0% 15%'"
    >
      <div
        fxFlex="52.5%"
        fxFlex.sm="100%"
        fxFlex.xs="100%"
        [style.padding]="'0em 2em'"
      >
        <p class="p6">
          <span class="b1">La integración de la biodiversidad</span><br />
          y la comercialización con el usos de herramientas digitales busca
          contribuir al empoderamiento de los miembros de la comunidad agrícola.
        </p>
      </div>
      <div
        fxFlex="47.5%"
        fxFlex.sm="100%"
        fxFlex.xs="100%"
        [style.margin]="'0px 0px -6.5px 0px'"
      >
        <img
          src="https://wikipapa.org/images/agricultor-celular.jpg"
          style="object-fit: contain; background-size: cover"
          width="100%"
        />
      </div>
    </div>

    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around center"
      [style.background-color]="'#ffffff'"
      [style.padding]="'0% 15%'"
    >
      <div
        fxFlex="55"
        fxFlex.sm="100%"
        fxFlex.xs="100%"
        [style.margin]="'0px 0px -6.5px 0px'"
      >
        <img
          src="https://wikipapa.org/images/grupo-papas.jpg"
          style="object-fit: contain; background-size: cover"
          width="100%"
        />
      </div>
      <div
        fxFlex="45"
        fxFlex.sm="100%"
        fxFlex.xs="100%"
        [style.padding]="'0em 2em'"
      >
        <p class="p6">
          <span class="b1">Cada variedad de papa</span><br />
          son mezclas de varios genotipos con características propias y
          relacionadas con los usos y costumbres de los agricultores que las
          emplean en sus fincas.
        </p>
      </div>
    </div>

    <!-- ALIADOS | COLABORADORES | AUSPICIADORES | IMPLEMENTADORES -->
    <br><br><br>
    <div style="text-align: center;">
      <p style="font-family: 'Arial', sans-serif; font-size: 18px; color: #B8ACA2; font-weight: 400;">
        Auspiciado por
      </p>
      <img
        src="assets/images/entities/cgiar.png"
        style="object-fit: contain; background-size: cover; height: 80px; padding-right: 30px;"
      />
      <img
        src="assets/images/entities/FAO.jpg"
        style="object-fit: contain; background-size: cover; height: 80px;"
      />
    </div>

    <br><br><br>
    <div style="text-align: center;">
      <p style="font-family: 'Arial', sans-serif; font-size: 18px; color: #B8ACA2; font-weight: 400;">
        Aliados y colaboradores
      </p>
      <img
        src="assets/images/entities/cip.png"
        style="object-fit: contain; background-size: cover; height: 80px; padding-right: 30px;"
      />
      <img
        src="assets/images/entities/PROSUCO.jpg"
        style="object-fit: contain; background-size: cover; height: 80px; padding-right: 30px;"
      />
      <img
        src="assets/images/entities/chile.png"
        style="object-fit: contain; background-size: cover; height: 80px; padding-right: 30px;"
      />
      <img
        src="assets/images/entities/yanapai.png"
        style="object-fit: contain; background-size: cover; height: 80px; padding-right: 30px;"
      />
      <img
        src="assets/images/entities/aguapan.png"
        style="object-fit: contain; background-size: cover; height: 80px;"
      />
    </div>
    <br>
    <div style="text-align: center;">
      <img
        src="assets/images/entities/AGROSAVIA.png"
        style="object-fit: contain; background-size: cover; height: 80px; padding-right: 30px;"
      />
      <img
        src="assets/images/entities/pataz.png"
        style="object-fit: contain; background-size: cover; height: 80px; padding-right: 30px;"
      />
      <img
        src="assets/images/entities/unc.png"
        style="object-fit: contain; background-size: cover; height: 80px; padding-right: 30px;"
      />
      <img
        src="assets/images/entities/resonanz.png"
        style="object-fit: contain; background-size: cover; height: 80px; padding-right: 30px;"
      />
      <img
        src="assets/images/entities/metrika.png"
        style="object-fit: contain; background-size: cover; height: 60px;"
      />
    </div>

    <!-- <hr>

    <div [style.padding]="'0% 15%'">
      <img
        src="assets/images/entities/business_and_entities_3.jpg"
        style="object-fit: contain; background-size: cover"
        width="100%"
      />
    </div>

    <div style="text-align: center;">
      <img
        src="assets/images/entities/PROSUCO.jpg"
        style="object-fit: contain; background-size: cover; height: 80px; padding-right: 15px;"
      />
      <img
        src="assets/images/entities/AGROSAVIA.png"
        style="object-fit: contain; background-size: cover; height: 80px; padding-right: 15px;"
      />
      <img
        src="assets/images/entities/FAO.jpg"
        style="object-fit: contain; background-size: cover; height: 80px;"
      />
    </div>

    <div style="text-align: center;">
      <img
        src="assets/images/entities/chile.png"
        style="object-fit: contain; background-size: cover; height: 180px;"
      />
    </div> -->

    <br />
    <br />
    <br>
    <br>
  </div>
</div>
